import React from 'react';
import Button from './Button';

const SecondaryCTA = ({ children, onClick, className = '', ...props }) => {
    return (
        <Button
            variant="outline"
            className={`text-white border-white/50 hover:bg-white/10 font-semibold rounded-[30px] px-[32px] py-[16px] text-[16px] sm:text-[18px] transition-all duration-300 ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </Button>
    );
};

export default SecondaryCTA;
